export const componentMap = {
  "default":"p",
  "h1":"h1","H1":"h1",
  "h2":"h2","H2":"h2",
  "h3":"h3","H3":"h3",
  "h4":"h4","H4":"h4",
  "h5":"h5","H5":"h5",
  "h6":"h6","H6":"h6",
  "p":"p","P":"p",
  "pre":"pre","PRE":"pre",
  "ul":"ul","UL":"ul",
  "li":"li","LI":"li",
  "div":"div","DIV":"div",
  "section":"section","SECTION":"section",
  "nav":"nav","NAV":"nav",
  "article":"article","ARTICLE":"article",
  "img":"img","IMG":"img",
  "html":"html","HTML":"html"
};
